// @mui material components
import Grid from "@mui/material/Grid";
import colors from "../../assets/theme/base/colors";

import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import AppIconButton from "../../components/AppIconButton/ApplicationIconButton";
import MDBox from "../../components/MDBox";
import ApplicationsCard from "./ApplicationsCard";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import ReleasedApplications from "../../common/ReleasedApplications";
import AppsIcon from "@mui/icons-material/Apps";
import "react-multi-carousel/lib/styles.css";
import JTCGeneralCarousel from "../../components/Carousel/JTCGeneralCarousel";
import { Stack } from "@mui/material";
import MDTypography from "../../components/MDTypography";

const DashboardApplicationContainer = () => {
  const user = useSelector((state) => state.user);
  const [myApps, setMyApps] = useState({
    public: undefined,
    private: undefined,
  });

  useEffect(() => {
    getMyApplications();
  }, []);

  function getMyApplications() {
    var accessibleApps = [];
    var accessiblePublicApps = [];
    var exist = false;

    // Filter Apps that require claims
    user.roleClaims.filter(
      // get only the elements that matches
      (el) =>
        ReleasedApplications.some(
          // check if there is any element in B that is contained in the current element of A
          (obj) => {
            if (obj.appRequiredClaim != null) {
              if (
                el.toLowerCase().includes(obj.appRequiredClaim.toLowerCase())
              ) {
                accessibleApps.indexOf(obj) === -1
                  ? accessibleApps.push(obj)
                  : (exist = true);
              }
            } else if (obj.appCategory == "private") {
              accessibleApps.indexOf(obj) === -1
                ? accessibleApps.push(obj)
                : (exist = true);
              accessibleApps.push(obj);
            }
          }
        )
    );
    // Filter Apps that does notrequire claims

    ReleasedApplications.map(
      // check if there is any element in B that is contained in the current element of A
      (obj) => {
        if (
          (obj.appRequiredClaim == null ||
            obj.appRequiredClaim == undefined ||
            obj.appRequiredClaim == "") &&
          obj.appCategory == "public"
        ) {
          accessiblePublicApps.push(obj);
        }
      }
    );

    // Sort private apps by index (apps without an index appear last)
    const sortedPrivateApps = accessibleApps
      .filter((app) => app.appCategory === "private") // Filter for private apps
      .map((app) => ({
        ...app,
        index: app.index ?? Infinity, // Assign Infinity to apps without an index
      }))
      .sort((a, b) => a.index - b.index); // Sort by index in ascending order

    const listOfPrivateApps = sortedPrivateApps.map((element) => {
      return (
        element.appCategory == "private" && (
          <AppIconButton
            key={element.appTag}
            avatarIcon={element.appIcon}
            avatarTag={element.appTag}
            avatarShortTag={element.appShortTag}
            avatarBorderColor={colors.black.focus}
            avatarBorderWidth={2}
            appHref={element.appUrl}
            avatarBoxShadow={8}
            avatarWidth={"4vw"}
            avatarMinWidth={"4vw"}
            avatarTagColor={colors.black.main}
            avatarBgColor={colors.JTC.loginGrey1}
            p={1.2}
            isShowToolTip={true}
            avatarTooltip={element.appDescription}
            fontSize={"1rem"}
            isOpenNewTab={element.isOpenNewTab}
          />
        )
      );
    });
    const listOfPublicApps = accessiblePublicApps.map((element) => {
      return (
        <AppIconButton
          key={element.appTag}
          avatarIcon={element.appIcon}
          avatarTag={element.appTag}
          avatarShortTag={element.appShortTag}
          avatarBorderColor={colors.black.focus}
          avatarBorderWidth={2}
          appHref={element.appUrl}
          avatarBoxShadow={8}
          avatarWidth={"4vw"}
          avatarMinWidth={"4vw"}
          avatarTagColor={colors.black.main}
          avatarBgColor={colors.JTC.loginGrey1}
          p={1.2}
          isShowToolTip={true}
          avatarTooltip={element.appDescription}
          fontSize={"1rem"}
          isOpenNewTab={element.isOpenNewTab}
        />
      );
    });

    setMyApps({ private: listOfPrivateApps, public: listOfPublicApps });

    return listOfPrivateApps;
  }

  const noApplicationsIndicator = () => {
    return (
      <MDBox
        width="100%"
        height="100%"
        display="flex"
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Stack
          display="flex"
          justifyContent="center"
          alignItems={"center"}
          sx={{
            flexDirection: "column", // Set the direction to column
          }}
        >
          <AppsIcon
            fontSize="large"
            sx={{
              color: "rgba(0, 0, 0, 0.3)", // Adjust the alpha value (0.7) to control the opacity
            }}
          />
          <MDTypography
            variant="h6"
            sx={{
              paddingLeft: "0.3rem",
              fontWeight: "700",
              fontSize: 20,
              paddingTop: 1.2,
              color: "rgba(0, 0, 0, 0.215)", // Adjust the alpha value (0.7) to control the opacity
              pointerEvents: "none", // Disable pointer events
              userSelect: "none", // Disable text selection
            }}
          >
            {"No Applications "}
          </MDTypography>
        </Stack>
      </MDBox>
    );
  };

  return (
    <MDBox pt={4}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} sx={{}}>
          <ApplicationsCard
            title={"Public Applications"}
            bgcolor={colors.JTCElectricBlue}
            color={"primary"}
            loading={false}
            content={
              myApps?.public !== null && (
                <MDBox
                  color={"white"}
                  minWidth="10rem"
                  display="flex"
                  sx={{ flexWrap: "wrap", alignContent: "flex-start" }}
                >
                  {(myApps?.public?.length ?? -1) === 0
                    ? // Show No applications
                    noApplicationsIndicator()
                    : myApps?.public?.map((el) => (
                      <MDBox p={1} pt={2} key={el.key}>
                        {el}
                      </MDBox>
                    ))}
                </MDBox>
              )
            }
            icon={
              <PlaylistAddCheckCircleIcon
                color={colors.black.focus}
                fontSize="large"
              />
            }
          />
        </Grid>

        <Grid item xs={12} md={8} sx={{}}>
          <ApplicationsCard
            title={"My Applications"}
            bgcolor={colors.JTCElectricBlue}
            color={"primary"}
            loading={false}
            content={
              myApps?.private !== null && (
                <MDBox
                  color={"white"}
                  minWidth="10rem"
                  display="flex"
                  sx={{ flexWrap: "wrap", alignContent: "flex-start" }}
                >
                  {(myApps?.private?.length ?? -1) === 0
                    ? // Show No applications
                    noApplicationsIndicator()
                    : myApps?.private?.map((el) => (
                      <MDBox p={1} pt={2} key={el.key}>
                        {el}
                      </MDBox>
                    ))}
                </MDBox>
              )
            }
            icon={
              <PlaylistAddCheckCircleIcon
                color={colors.black.focus}
                fontSize="large"
              />
            }
          />
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default DashboardApplicationContainer;
